import React, { useState } from "react";
import styled from "styled-components";
import colors from "../../constatns/colors";
import useWindowDimensions from "../../constatns/size";
import { HiArrowNarrowDown } from "react-icons/hi";

import "../../styles/home.css";

function TokenChartDetail({title, description, titleStyle, subDescription}) {
    const { width, height } = useWindowDimensions();
    
  return (
        <Container width={width} height={height} id="about">
            <InnerContainer width={width} height={height}>
                <InnerContainer style={{flexDirection: "row", marginTop: 0,}}>
                    <Title style={titleStyle}>{title}:</Title>
                    <Description>{description}</Description>
                </InnerContainer>
                {subDescription && <SubDescription>{subDescription}</SubDescription>}
            </InnerContainer>
        </Container>
  );
}

const Container = styled.div`
    display: flex;
    justify-content: space-between;
    @media (max-width: 768px) {
        /* margin-right: 150px; */
    }
`

const InnerContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 50px ;
    color: ${colors.white};
    width: ${({width})=> width/4.5}px;

    @media (max-width: 768px) {
        width: ${({width})=> width * 1.3}px;
        margin-top: 5px ;
    }
`

const Title = styled.h2`
    color: white;
    font-weight: 500;
    margin: 0px;
`

const Description = styled.p`
    color: ${colors.grey};
    font-size: 20px;
    font-weight: bold;
    margin-top: 5px;
    margin-left: 10px;
`

const SubDescription = styled.p`
    color: ${colors.grey};
    font-size: 12px;
    /* margin: 0; */
    margin-top: -15px;
`
export default TokenChartDetail;
